/* unplugin-vue-components disabled */import __unplugin_components_0 from 'C:/Office/_LIVE/AgyagosLanyBFBASE/vue/src/components/BaseIcon.vue';
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.link ? 'BaseLink' : 'div',{tag:"component",attrs:{"link":_vm.link,"target":_vm.target}},[_c('button',{staticClass:"relative",class:[
      {
        'w-full': _vm.fit === 'full',
        'w-full md:w-auto': _vm.fit === 'auto',
        loading: _vm.isLoading,
        disabled: _vm.disabled,
        btn: _vm.type === 'button_primary',
        'cta-link': _vm.type === 'text',
        lighter: _vm.textColor === 'light',
        dark: _vm.appearance === 'dark',
        light: _vm.appearance === 'light',
        'light-error': _vm.appearance === 'light-error',
        'btn--lg': _vm.size === 'lg',
        'flex items-center justify-center': _vm.icon,
      } ],attrs:{"type":_vm.buttonType,"aria-label":_vm.ariaLabel}},[(_vm.loadingLabel)?_c('div',{staticClass:"absolute center-xy"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"spinner"})]):_vm._e(),(_vm.label)?_c('span',{class:{
        'absolute center-xy': _vm.fit === 'full',
        'flex items-center justify-center': _vm.icon,
      }},[(_vm.icon)?_c(__unplugin_components_0,{staticClass:"inline-block mr-2",attrs:{"icon":("uil:" + _vm.icon),"size":"sm"}}):_vm._e(),(_vm.isLoading)?[_vm._v(" "+_vm._s(_vm.loadingLabel)+" ")]:[_vm._v(" "+_vm._s(_vm.label)+" ")]],2):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }